export var provisionalKey = function (titleType, suffix) {
    return "ui-br-legaldeposits.".concat(titleType === "PERIODICAL" ? "provisionalPeriodical" : "provisionalTitle", ".").concat(suffix);
};
